import { HttpClient } from "@angular/common/http";
import { Injector } from "@angular/core";
import { AeronaveService } from "src/app/services/aeronave/aeronave.service";
import { ModeloAeronaveService } from "src/app/services/aeronave/modelo-aeronave.service";
import { RequisicaoClassService } from "src/app/services/compra/requisicao-class.service";
import { PessoaService } from "src/app/services/pessoa/pessoa.service";
import { PesEnderecoService } from "src/app/services/pessoa/pes-endereco.service";
import { AuthService } from "src/app/services/security/auth.service";
import { FinanceiroService } from "src/app/services/financeiro/financeiro.service";
import { FinanceiroBaixaService } from "src/app/services/financeiro/financeiro-baixa.service";
import { TipoCondPagtoService } from "src/app/services/financeiro/tipo-cond-pagto.service";
import { ContaService } from "src/app/services/financeiro/conta.service";
import { CartaoBandeiraService } from "src/app/services/financeiro/cartao-bandeira.service";
import { CentroCustoService } from "src/app/services/financeiro/centro-custo.service";
import { BancoService } from "src/app/services/financeiro/banco.service";
import { FiscalNaturezaOpService } from "src/app/services/fiscal/fiscal-natureza-op.service";
import { FiscalCfopService } from "src/app/services/fiscal/fiscal-cfop.service";
import { FiscalCstPisService } from "src/app/services/fiscal/fiscal-cst-pis.service";
import { FiscalNfeService } from "src/app/services/fiscal/fiscal-nfe.service";
import { FatorMoedaService } from "src/app/services/geral/fator-moeda.service";
import { EndEstadoService } from "src/app/services/endereco/end-estado.service";

export class ConstantsAero {

  readonly PREFIX_MENU = 'label_sysmenu_';
  readonly PREFIX_FIELD = 'label_sysfield_';
  readonly PREFIX_TABLE = 'label_systab_';

  static readonly DATE_FMT_BR = 'dd/MMM/yyyy';
  static readonly DATE_TIME_FMT_BR = `${ConstantsAero.DATE_FMT_BR} hh:mm:ss`;

  static readonly SEPAR_CSV = ';';

  readonly maxDigitisFieldsNumber = 4;
  readonly maxDigitisFieldsNumberCompra = 2;

  readonly opSimNao = ['SIM', 'NÃO'];
  readonly opRegTributario = ['SIMPLES NACIONAL', 'LUCRO PRESUMIDO', 'LUCRO REAL'];
  readonly opContribuinte = ['ISENTO', 'SIM', 'NÃO'];
  readonly opStatus = ['Ativo', 'Inativo'];
  readonly opSexo = ['M', 'F'];
  readonly opEstadoCivil = ['Casado', 'Divorciado', 'Separado Judicialmente', 'Solteiro', 'Viúvo'];
  readonly opTipoTelefone = ['Celular', 'Comercial', 'Fax', 'Outros', 'Recado', 'Residencial', 'Responsavel'];
  readonly opTipoConta = ['Corrente', 'Poupança', 'Investimento'];
  readonly opTipoPagamento = ['Boleto', 'Cobrança', 'Comercial', 'Correspondência', 'Entrega', 'Faturamento', 'Outro', 'Recado',];
  readonly opStatusPendente = ['OK', 'SPC', 'SERASA', 'SPC/SERASA', 'INTERNA', 'SEM CONSULTA'];
  readonly opCategoria = ['RECEITA/DESPESA', 'TRANSFERÊNCIA']
  readonly opItensStatusImpImportador = ['01 - Aberto', '02 - Definido', '03 - Def. Agentes', '04 - Tradução', '05 - Info. Canal', '06 - Nfe', '07 - Transporte', '08 - Concluído'];
  readonly opItensStatusImpCarga = ['01 - Início', '02 - WR', '03 - AWB Inicial', '04 - AWB Final', '05 - Concluído',];
  readonly opItensStatusImpAduaneiro = ['01 - Início', '02 - Numerário', '03 - DTA', '04 - Armazenagem', '05 - DI', '06 - Carregamento', '07 - Concluído'];
  readonly opItensCanais = ['Branco', 'Cinza', 'Amarelo', 'Verde', 'Vermelho'];
  readonly opItensStatusHistorico = ['Aberto', 'Fechado'];
  readonly opItensEndPadrao = ['S', 'N'];
  readonly opTipoPessoa = [{ label: 'Jurídica', value: 'J' }, { label: 'Física', value: 'F' }, { label: 'Externo', value: 'E' }];;
  readonly opItensModal = ['Aeroviário', 'Ferroviário', 'Rodoviário', 'Aquaviário', 'Dutoviário'];
  readonly opDebitoCredito = ['D', 'C'];
  readonly opPreCompraCateg = ['DESPESA', 'TRANSFERÊNCIA'];
  readonly opPreCompraTpOrigem = ['NACIONAL', 'IMPORTAÇÃO'];
  readonly opPreCompraStatus = ['ABERTO', 'FINALIZADO', 'FATURADO', 'CANCELADO'];
  readonly opPreCompraItensCore = ['S', 'N'];
  readonly opPreEtapaCadastro = ['COMPLETO']; //Verificar com o MARCELO os demais campos
  readonly opVendedorTipo = ['FIXO', 'VARIÁVEL'];
  readonly opPedidoCompraStatus = ['ABERTO'];
  readonly opPedidoCompraPrioridade = ['NORMAL', 'URGENTE', 'AOG'];
  readonly opPedidoCompraTipo = ['NACIONAL', 'IMPORTAÇÃO'];
  /* readonly opExportArquivo = ['CSV', 'Excel', 'HTML', 'PDF', 'TEXTO', 'XML']; */
  readonly opExportArquivo = [
    { nome: 'CSV', modal: 'csv' },
    { nome: 'Excel', modal: 'excel' },
    { nome: 'HTML', modal: 'html' },
    { nome: 'PDF', modal: 'pdf' },
    { nome: 'TXT', modal: 'txt' },
    { nome: 'XML', modal: 'xml' }
  ];
  readonly opShipping = [
    { nome: 'Email', modal: 'email' },
    /* { nome: 'WhatsApp', modal: 'whatsapp' } */
  ];
  readonly oPedidoCompraItensStatus = ['Aberto', 'Cancelado']
}

export class QueryGeneric {

  api: any;
  auth: AuthService;

  constructor(
    private className: string,
    protected http: HttpClient,
    private injectorObj: Injector
  ) {
    this.auth = this.injectorObj.get(AuthService);

    if (className == 'RequisicaoClass') {
      this.api = new RequisicaoClassService(http);
    }
    else if (className == 'Aeronave') {
      this.api = new AeronaveService(http);
    }
    else if (className == 'ModeloAeronave') {
      this.api = new ModeloAeronaveService(http);
    }
    else if (className == 'Financeiro') {
      this.api = new FinanceiroService(http);
    }
    else if (className == 'FinanceiroBaixa') {
      this.api = new FinanceiroBaixaService(http);
    }
    else if (className == 'TipoCondPagto') {
      this.api = new TipoCondPagtoService(http);
    }
    else if (className == 'Conta') {
      this.api = new ContaService(http);
    }
    else if (className == 'CartaoBandeira') {
      this.api = new CartaoBandeiraService(http);
    }
    else if (className == 'CentroCusto') {
      this.api = new CentroCustoService(http);
    }
    else if (className == 'Banco') {
      this.api = new BancoService(http);
    }
    else if (className == 'Pessoa') {
      this.api = new PessoaService(http);
    }
    // Aliases de Pessoa usados na NFe (pessoaCliFor, pessoaTransp, pessoaVend, etc.)
    else if (className == 'PessoaCliFor' || className == 'PessoaCliForVenda' ||
             className == 'PessoaCliForEntrega' || className == 'PessoaTransp' ||
             className == 'PessoaVend') {
      this.api = new PessoaService(http);
    }
    // Endereço de entrega / endereço genérico
    else if (className == 'PesEnderecoEntrega' || className == 'EndEndereco') {
      this.api = new PesEnderecoService(http);
    }
    // Aeronave (inclui possível typo 'Aeronvave' vindo do banco)
    else if (className == 'Aeronvave') {
      this.api = new AeronaveService(http);
    }
    // Fiscal
    else if (className == 'FiscalNaturezaOp') {
      this.api = new FiscalNaturezaOpService(http);
    }
    else if (className == 'FiscalCfop') {
      this.api = new FiscalCfopService(http);
    }
    else if (className == 'FiscalCstPis' || className == 'FiscalCstCofins') {
      this.api = new FiscalCstPisService(http);
    }
    else if (className == 'FiscalNfeRef') {
      this.api = new FiscalNfeService(http);
    }
    // Fator de Moeda
    else if (className == 'FatorMoeda') {
      this.api = new FatorMoedaService(http);
    }
    // Estado (UF)
    else if (className == 'EndEstado') {
      this.api = new EndEstadoService(http);
    }
  }

  query() {
    if (this.api) {
      return this.api.findAll(this.auth.empresa.id);
    }
    else {
      console.warn('API não definida para a classe: ' + this.className);
      return { toPromise: () => Promise.resolve([]) } as any;
    }
  }
}
